<div class="legal-container">
    <div class="header-left">
        <button type="button" class="back-btn" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            <span>Retour à l'accueil</span>
        </button>
    </div>
    <header class="legal-header">
        <div class="logo-container">
            <img src="assets/images/logo-2.png" alt="YokaStar Logo">
        </div>
        <h1>Conditions d'Utilisation</h1>
        <p class="subtitle">Dernière mise à jour : {{ currentDate | date: 'longDate' }}</p>
    </header>

    <main class="legal-content">
        <section class="intro-section">
            <p>
                Bienvenue sur <strong>YokaStar</strong>. En utilisant notre plateforme, vous acceptez les présentes conditions d'utilisation.
                Veuillez les lire attentivement avant d'utiliser nos services.
            </p>
        </section>

        <section class="acceptance-section">
            <h2><i class="fas fa-check-circle icon"></i> Acceptation des Conditions</h2>
            <p>
                En accédant et en utilisant YokaStar, vous acceptez d'être lié par ces conditions d'utilisation.
                Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre plateforme.
            </p>
        </section>

        <section class="services-section">
            <h2><i class="fas fa-star icon"></i> Description des Services</h2>
            <div class="grid-layout">
                <div class="service-item">
                    <i class="fas fa-video"></i>
                    <h3>Vidéos Personnalisées</h3>
                    <p>Commandez des vidéos personnalisées de vos célébrités préférées</p>
                </div>
                <div class="service-item">
                    <i class="fas fa-comments"></i>
                    <h3>Interactions</h3>
                    <p>Communiquez directement avec les célébrités</p>
                </div>
                <div class="service-item">
                    <i class="fas fa-shopping-cart"></i>
                    <h3>Transactions</h3>
                    <p>Effectuez des paiements sécurisés pour vos commandes</p>
                </div>
            </div>
        </section>

        <section class="obligations-section">
            <h2><i class="fas fa-user-shield icon"></i> Obligations des Utilisateurs</h2>
            <div class="grid-layout">
                <div class="obligation-item">
                    <span class="obligation-number">1</span>
                    <div>
                        <h3>Compte Utilisateur</h3>
                        <p>Maintenir des informations de compte exactes et à jour</p>
                    </div>
                </div>
                <div class="obligation-item">
                    <span class="obligation-number">2</span>
                    <div>
                        <h3>Conduite</h3>
                        <p>Respecter les autres utilisateurs et les célébrités</p>
                    </div>
                </div>
                <div class="obligation-item">
                    <span class="obligation-number">3</span>
                    <div>
                        <h3>Contenu</h3>
                        <p>Ne pas publier de contenu illégal ou inapproprié</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="payments-section">
            <h2><i class="fas fa-credit-card icon"></i> Paiements et Remboursements</h2>
            <div class="payment-terms">
                <h3>Conditions de Paiement</h3>
                <ul>
                    <li>Les paiements sont sécurisés via notre système de paiement</li>
                    <li>Les prix sont indiqués en USD</li>
                    <li>Les taxes applicables sont incluses dans le prix</li>
                </ul>
                <h3>Politique de Remboursement</h3>
                <ul>
                    <li>Les remboursements sont traités sous 14 jours ouvrables</li>
                    <li>Conditions spécifiques selon le type de service</li>
                    <li>Contactez notre service client pour toute demande</li>
                </ul>
            </div>
        </section>

        <section class="liability-section">
            <h2><i class="fas fa-balance-scale icon"></i> Limitation de Responsabilité</h2>
            <p>
                YokaStar ne peut être tenu responsable des dommages directs ou indirects résultant de l'utilisation de notre plateforme.
                Nous nous réservons le droit de modifier ou d'interrompre nos services à tout moment.
            </p>
        </section>

        <section class="contact-section">
            <h2><i class="fas fa-envelope icon"></i> Contact</h2>
            <p>
                Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :
            </p>
            <div class="contact-card">
                <p><strong>Email : </strong> <a href="mailto:legal&#64;yokastar.com">legal&#64;yokastar.com</a></p>
                <p><strong>Adresse :</strong> 11 Bis, Av. Okapi; Q/Congo C/Ngaliema Kinshasa/ R.D.Congo</p>
            </div>
        </section>
    </main>

    <app-legal-footer></app-legal-footer>
</div> 